<template>
  <div v-if="isPending" class="om-pending" :class="compact ? 'om-pending-compact' : 'om-pending-docked'">
    <p class="om-pending-text">
      {{ compact ? copy.pendingShort : copy.pendingBar }} <strong>{{ version.label }}</strong>
    </p>
    <button type="button" class="om-button om-pending-button" :disabled="isSaving" @click="acknowledge">
      {{ isSaving ? copy.acknowledging : copy.acknowledge }}
    </button>
  </div>
</template>

<script>
import { MANUAL_COPY } from './manualCopy';

export default {
  name: 'ManualPendingBar',
  props: {
    manualKey: { type: String, required: true },
    compact: { type: Boolean, default: false },
  },
  data() {
    return { copy: MANUAL_COPY, isSaving: false };
  },
  computed: {
    manual() {
      return this.$store.state.operationsManual.manuals.find((candidate) => candidate.key === this.manualKey) || null;
    },
    version() {
      return this.manual ? this.manual.current_version : null;
    },
    isPending() {
      return Boolean(this.version && !this.version.is_acknowledged);
    },
  },
  methods: {
    async acknowledge() {
      this.isSaving = true;
      try {
        await this.$store.dispatch('operationsManual/acknowledge', { manualKey: this.manualKey, versionId: this.version.id });
      } catch (error) {
        this.$notify({ type: 'danger', message: this.copy.loadError });
      } finally {
        this.isSaving = false;
      }
    },
  },
};
</script>

<style scoped>
.om-pending { display: flex; align-items: center; justify-content: space-between; gap: 12px; background: #fffaf0; border: 1px solid rgba(236, 170, 51, .5); border-radius: var(--om-radius); }
.om-pending-text { margin: 0; color: var(--om-ink); line-height: 1.4; }
.om-pending-docked { position: sticky; bottom: 12px; z-index: 20; flex-wrap: wrap; margin-top: 20px; padding: 12px 14px 12px 16px; box-shadow: 0 8px 24px rgba(26, 36, 32, .12); }
.om-pending-docked .om-pending-text { font-size: 14px; flex: 1 1 220px; }
.om-pending-compact { display: none; padding: 8px 8px 8px 12px; }
.om-pending-compact .om-pending-text { font-size: 13px; }
.om-pending-compact .om-pending-button { min-height: 36px; padding: 6px 12px; font-size: 13px; flex-shrink: 0; }
@media (max-width: 991px) {
  .om-pending-docked { display: none; }
  .om-pending-compact { display: flex; }
}
</style>
